import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Jumbotron, Header, Footer, Message } from 'components';
import { ContextProvider, ContextInterface } from './AppContext';
import Routes from './routes';

const App: React.FC = _ => {
  const [msg, setMsg] = useState<any[]>([]);
  const context: ContextInterface = {
    messages: msg,
    setMessage: (message: string, type: string) => {
      setMsg(oldMessages => {
        if (oldMessages.length > 2) {
          oldMessages = oldMessages.slice(1);
        }
        const lastNumber = oldMessages.length > 0 ? oldMessages[oldMessages.length - 1].id + 1 : 0;
        return [...oldMessages, {id: lastNumber, message, type }] 
      });
    },
  };

  return (
    <Router>
      <ContextProvider value={context}>
        <div className="app-wrapper">
          <Message />
          <Header />
          <Jumbotron />
          <Routes />
          <Footer />
        </div>
      </ContextProvider>
    </Router>
  );
}

export default App;
